import { emptyOrEmptyHTML } from "../util" ;
import { Controller } from "stimulus"; 
export default class extends Controller {
  static get targets() {
    return ['tabNav', 'tabContent', 'default'];
  }


  initialize(){

    this.defaultTarget.click(); 
  }

  checkData(e){
    let id = e.target.dataset.tabId; 
    let nav  = e.target.parentNode; 
    let activeElem = document.getElementById(id); 
    if (!emptyOrEmptyHTML(activeElem)){
      e.preventDefault();
      this.toggleElements(id, nav);
    }
  }

  showTab(e){
    let id = e.target.dataset.tabId;
    this.toggleElements(id, e.target.parentNode);
  }

  toggleElements(id, activeNav){
    this.tabNavTargets.forEach(function(elem, i) {
      elem.classList.toggle('active', elem === activeNav); 
    })
    this.tabContentTargets.forEach(function(elem,i) {
      elem.classList.toggle('active', elem.id ===  id); 
    })


  }

 
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/load_tab_data_controller.js